import axios from 'axios'
import { setAuthorizationToken, setDeviceToken } from '../utils/setAuthorizationToken'
import {
  API_URL,
  SET_CURRENT_USER
} from '../constants'

export function getCompaniesFromToken (token, usageString) {
  let usage = 0
  switch (usageString) {
    case 'bookingportal':
      usage = 1
      break
  }
  let url = API_URL + '/Embedded/Companies/'
  let data = {
    token: token,
    usage: usage
  }
  return dispatch => {
    return axios.post(url, data)
  }
}

export function loginWithToken (token, usageString) {
  let usage = 0
  switch (usageString) {
    case 'bookingportal':
      usage = 1
      break
  }
  let url = API_URL + '/Embedded/LoginToken/'
  let data = {
    token: token,
    usage: usage
  }

  return dispatch => {
    window.localStorage.clear()
    return axios.post(url, data).then(res => {
      const token = res.data.Token
      window.localStorage.setItem('user_token', token)
      window.localStorage.setItem('user_data', JSON.stringify(res.data))
      setAuthorizationToken(token)
      setDeviceToken(res.data.DeviceToken)
      dispatch(setCurrentUser(res.data))
      return res
    })
  }
}

export function setCurrentUser (user) {
  return {
    type: SET_CURRENT_USER,
    user
  }
}

export function logout () {
  return dispatch => {
    window.localStorage.removeItem('user_token')
    window.localStorage.removeItem('user_data')
    window.localStorage.removeItem('user_language')
    setAuthorizationToken(false)
    setDeviceToken(false)
    dispatch(setCurrentUser({}))
  }
}

export function getStyle (token, usageString) {
  let usage = 0
  switch (usageString) {
    case 'bookingportal':
      usage = 1
      break
  }
  let url = API_URL + '/Embedded/Companies/Style/'
  let data = {
    token: token,
    usage: usage
  }
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/embedded.js